import { Injectable } from '@angular/core';
import { BehaviorSubject, shareReplay, tap } from 'rxjs';
import { filter, pairwise, startWith } from 'rxjs/operators';
import { SpaceRepository } from '../../state/space.repository';
import { TelemetryService } from '../telemetry.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class BreakoutRoomsManagementService {
  private _breakoutRoomsManagementScreenShown$ = new BehaviorSubject<boolean>(false);
  public breakoutRoomsManagementScreenShown$ = this._breakoutRoomsManagementScreenShown$
    .asObservable()
    .pipe(
      tap((val) => {
        this.telemetry.setSessionVars({
          breakouts_manage_mode_open: val,
        });
      }),
      shareReplay(1),
    );

  constructor(private telemetry: TelemetryService, private spaceRepo: SpaceRepository) {
    this.subscribeToHostDemotion();
  }

  /**
   * When the current user is demoted from host to participant, close the breakout management view
   * (participants cannot manage breakout rooms).
   */
  private subscribeToHostDemotion(): void {
    this.spaceRepo.isCurrentUserHost$
      .pipe(
        startWith(this.spaceRepo.isCurrentUserHost()),
        pairwise(),
        filter(([wasHost, isHost]) => wasHost && !isHost),
        untilDestroyed(this),
      )
      .subscribe(() => {
        if (this.isBreakoutRoomsManagementScreenShown()) {
          this.hideBreakoutRoomsManagementScreen();
        }
      });
  }

  showBreakoutRoomsManagementScreen() {
    this._breakoutRoomsManagementScreenShown$.next(true);
  }

  hideBreakoutRoomsManagementScreen() {
    this._breakoutRoomsManagementScreenShown$.next(false);
  }

  isBreakoutRoomsManagementScreenShown() {
    return this._breakoutRoomsManagementScreenShown$.getValue();
  }
}
